function isCartApiUrl(url) {
	try {
		return /\/cart\/(add|change|update|clear)(\.js)?$/.test(
			new URL(url, window.location.origin).pathname
		)
	} catch {
		return false
	}
}

function isCartPageUrl(url) {
	try {
		return /\/cart\/?$/.test(new URL(url, window.location.origin).pathname)
	} catch {
		return false
	}
}

function safeCall(fn) {
	try {
		fn()
	} catch (error) {
		console.error(error)
	}
}

const swup =
	typeof Swup === 'function' && !window.Shopify?.designMode
		? new Swup({
				ignoreVisit: (url, { el } = {}) => {
					if (el?.closest('[data-no-swup], [data-ajax-cart-request-button]')) {
						return true
					}

					return isCartApiUrl(url)
				}
			})
		: null

function visit(url, el, event) {
	if (swup && !swup.shouldIgnoreVisit(url, { el, event })) {
		swup.navigate(url)
		return
	}

	window.location.assign(url)
}

const header = qs('#header')
const menuToggle = qs('#menuToggle')
const menuModal = qs('#menuModal')
const menuToggles = qsa('[data-menu-toggle], #menuToggle')

let lazyLoadInstance = typeof LazyLoad === 'function' ? new LazyLoad({}) : null
let productSwiper = null
let productMediaObserver = null
let revealObserver = null
let videoObserver = null
let pageMenuObserver = null
let productDetailsOnResize = null
let pageMenuOnResize = null
let collectionAjaxinate = null
let blogAjaxinate = null
let collectionRestoreId = 0

const COLLECTION_RESTORE_KEY = 'rebe:collection-restore'

if (header && typeof Headroom === 'function') {
	new Headroom(header, {
		offset: {
			up: 100,
			down: 50
		},
		classes: {
			top: 'header--top',
			notTop: 'header--not-top',
			pinned: 'header--pinned',
			unpinned: 'header--unpinned'
		}
	}).init()
}

const onMenuKeydown = (e) => {
	if (e.key === 'Escape') closeMenu()
}

function closeMenu() {
	if (!menuModal?.hasAttribute('open')) return

	menuModal.close()
	header?.classList.remove('active')
	menuToggle?.setAttribute('aria-expanded', false)
	document.removeEventListener('keydown', onMenuKeydown)
}

function closeAllModals() {
	closeMenu()

	qsa('dialog[open]').forEach((dialog) => {
		try {
			dialog.close()
		} catch (error) {}
	})

	qsa(
		'[data-modal-toggle-hero][aria-expanded="true"], [data-media-lightbox-toggle-hero][aria-expanded="true"]'
	).forEach((el) => {
		el.setAttribute('aria-expanded', false)
	})
}

function openMenu() {
	if (!menuModal) return

	menuModal.show()
	header?.classList.add('active')
	menuToggle?.setAttribute('aria-expanded', true)
	document.addEventListener('keydown', onMenuKeydown)
}

menuToggles.forEach((toggle) => {
	toggle.addEventListener('click', () => {
		if (menuModal?.hasAttribute('open')) {
			closeMenu()
		} else {
			openMenu()
		}
	})
})

function toggleCart() {
	const modal = qs('[data-modal="cartModal"]')
	const heroToggle = qs('[data-modal-toggle-hero="cartModal"]')
	if (!modal) return

	const isOpen = modal.hasAttribute('open')

	if (isOpen) {
		modal.close()
		heroToggle?.setAttribute('aria-expanded', false)
	} else {
		modal.showModal()
		heroToggle?.setAttribute('aria-expanded', true)
	}
}

function setModalOpen(modal, heroToggle, open, method = 'showModal') {
	if (!modal) return

	if (open) {
		modal[method]()
		heroToggle?.setAttribute('aria-expanded', true)

		if (modal.dataset.modal == 'searchModal') {
			const input = qs('input[type="search"]')
			setTimeout(() => input.focus(), 100)
		}
		return
	}

	modal.close()
	heroToggle?.setAttribute('aria-expanded', false)
}

document.addEventListener(
	'click',
	(e) => {
		if (
			e.defaultPrevented ||
			e.button !== 0 ||
			e.metaKey ||
			e.ctrlKey ||
			e.shiftKey ||
			e.altKey
		) {
			return
		}

		const detailsLink = e.target.closest('details a[href]')
		if (!detailsLink) return

		e.preventDefault()
		e.stopPropagation()

		visit(detailsLink.href, detailsLink, e)
	},
	true
)

document.addEventListener('click', (e) => {
	const viewBtn = e.target.closest('[data-collection-view-toggle]')
	if (viewBtn) {
		const collection = qs('#collection')
		if (!collection) return

		collection.dataset.collectionView = viewBtn.dataset.collectionViewToggle
		qsa('[data-collection-view-toggle]').forEach((btn) => {
			btn.classList.toggle('active', btn === viewBtn)
		})
		return
	}

	const modalToggle = e.target.closest('[data-modal-toggle]')
	if (modalToggle) {
		e.preventDefault()
		const id = modalToggle.dataset.modalToggle
		const modal = qs(`[data-modal="${id}"]`)
		if (!modal) return

		setModalOpen(
			modal,
			qs(`[data-modal-toggle-hero="${id}"]`),
			!modal.hasAttribute('open')
		)
		return
	}

	const lightboxToggle = e.target.closest('[data-media-lightbox-toggle]')
	if (lightboxToggle) {
		e.preventDefault()
		const id = lightboxToggle.dataset.mediaLightboxToggle
		const modal = qs(`[data-media-lightbox="${id}"]`)
		if (!modal) return

		setModalOpen(
			modal,
			qs(`[data-media-lightbox-toggle-hero="${id}"]`),
			!modal.hasAttribute('open'),
			'show'
		)
		return
	}

	const collectionCard = e.target.closest('#collection [data-product-card]')
	if (
		collectionCard &&
		!e.metaKey &&
		!e.ctrlKey &&
		!e.shiftKey &&
		!e.altKey &&
		!e.target.closest('[data-product-card-variation-toggle]')
	) {
		saveCollectionRestore(collectionCard)
	}

	const thumb = e.target.closest('.product__thumbnails-item')
	if (thumb) {
		const media = getProductMedia()
		if (!media) return

		const index = media.thumbnails.indexOf(thumb)
		const mediaItem = media.mediaItems[index]
		if (index === -1 || !mediaItem) return

		e.preventDefault()
		setActiveThumbnail(index, media.thumbnails)
		mediaItem.scrollIntoView({ behavior: 'smooth', block: 'start' })
		return
	}

	const detailsHeading = e.target.closest('[data-product-details-heading]')
	if (detailsHeading) {
		const type = detailsHeading.dataset.productDetailsHeading
		const exButton = qs('[data-product-details-heading].active')
		const exItem = qs('[data-product-details-block].active')
		const item = qsa('[data-product-details-block]').find(
			(el) => el.dataset.productDetailsBlock === type
		)

		if (!item || item === exItem) return

		exItem?.classList.remove('active')
		exButton?.classList.remove('active')
		exButton?.setAttribute('aria-expanded', 'false')

		item.classList.add('active')
		detailsHeading.classList.add('active')
		detailsHeading.setAttribute('aria-expanded', 'true')
		updateProductDetailsIndicator(detailsHeading)
	}
})

document.addEventListener('keydown', (e) => {
	if (e.key !== 'Escape') return

	qsa('[data-media-lightbox][open]').forEach((modal) => modal.close())
})

document.addEventListener('submit', (e) => {
	if (e.target.matches('[data-filter-form]')) {
		e.preventDefault()

		const query = new URLSearchParams(new FormData(e.target)).toString()
		visit(
			query ? `${window.location.pathname}?${query}` : window.location.pathname
		)
		return
	}

	if (e.target.matches('[data-blog-filter-form]')) {
		e.preventDefault()

		const blogUrl = e.target.dataset.blogUrl
		const tags = new FormData(e.target).getAll('tag')
		visit(tags.length ? `${blogUrl}/tagged/${tags.join('+')}` : blogUrl)
	}
})

document.addEventListener('reset', (e) => {
	if (e.target.matches('[data-filter-form]')) {
		setTimeout(() => visit(window.location.pathname))
		return
	}

	if (e.target.matches('[data-blog-filter-form]')) {
		const blogUrl = e.target.dataset.blogUrl
		setTimeout(() => visit(blogUrl))
	}
})

document.addEventListener('mouseout', (e) => {
	const wrapper = qs('#productSwatchWrapper')
	if (
		wrapper &&
		wrapper.contains(e.target) &&
		!(e.relatedTarget && wrapper.contains(e.relatedTarget))
	) {
		const currentSwatch = qs('#currentSwatchValue')
		const swatchValue = qs('#productSwatchValue')
		if (currentSwatch && swatchValue) {
			swatchValue.textContent = currentSwatch.dataset.productVariation
		}
	}
})

document.addEventListener('mouseover', (e) => {
	const swatch = e.target.closest('[data-product-variation]')
	if (!swatch) return

	const swatchValue = qs('#productSwatchValue')
	if (swatchValue) swatchValue.textContent = swatch.dataset.productVariation
})

const announcementSlides = qsa('[data-announcement-slide]')
if (announcementSlides.length > 1) {
	setInterval(() => {
		const active = qs('[data-announcement-slide].active')
		if (!active) return

		const activeIdx = announcementSlides.indexOf(active)
		active.classList.remove('active')
		active.setAttribute('aria-hidden', true)

		const nextSlide =
			activeIdx === announcementSlides.length - 1
				? announcementSlides[0]
				: announcementSlides[activeIdx + 1]

		nextSlide.classList.add('active')
		nextSlide.setAttribute('aria-hidden', false)
	}, 5000)
}

function initAjaxCart() {
	if (!window.liquidAjaxCart) return

	liquidAjaxCart.subscribeToCartAjaxRequests((state, subscribeToResult) => {
		subscribeToResult(() => {
			swup?.cache.clear()
			lazyLoadInstance?.update()
		})

		if (state.requestType !== 'add') return

		const form = state.info?.initiator
		const btn = form?.querySelector?.('button[type="submit"]')
		const btnInner = btn ? btn.innerHTML : ''
		if (btn) btn.innerHTML = window.variantStrings.adding

		subscribeToResult((result) => {
			if (result.responseData?.ok) toggleCart()

			if (btn) {
				setTimeout(() => {
					btn.innerHTML = btnInner
				}, 300)
			}
		})
	})

	if (typeof liquidAjaxCart.subscribeToCartSectionsUpdate === 'function') {
		liquidAjaxCart.subscribeToCartSectionsUpdate(() => {
			lazyLoadInstance?.update()
		})
	}
}

if (window.liquidAjaxCart) {
	initAjaxCart()
} else {
	document.body.addEventListener('liquidAjaxCartInit', initAjaxCart, {
		once: true
	})
}

function showReveals() {
	revealObserver?.disconnect()
	revealObserver = null

	const reveals = qsa('.reveal')
	if (!reveals.length) return

	revealObserver = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				entry.target.classList.toggle('entered', entry.isIntersecting)
			})
		},
		{
			rootMargin: '0px 0px -10% 0px',
			threshold: 0
		}
	)

	reveals.forEach((el) => revealObserver.observe(el))
}

const PAGE_MENU_FOOTER_LEAD = 300

function getPageMenuRootMargin(menu) {
	const rect = menu.getBoundingClientRect()

	return [
		`${-Math.round(rect.top)}px`,
		`${-Math.round(window.innerWidth - rect.right)}px`,
		`${-Math.round(window.innerHeight - rect.bottom - PAGE_MENU_FOOTER_LEAD)}px`,
		`${-Math.round(rect.left)}px`
	].join(' ')
}

function destroyPageMenuFooterOverlap() {
	pageMenuObserver?.disconnect()
	pageMenuObserver = null

	if (pageMenuOnResize) {
		window.removeEventListener('resize', pageMenuOnResize)
		pageMenuOnResize = null
	}

	qs('#pageNav')?.classList.remove('page-menu--hidden')
}

function initPageMenuFooterOverlap() {
	destroyPageMenuFooterOverlap()

	const menu = qs('#pageNav')
	const footer = qs('#footer')
	if (!menu || !footer) return

	const createObserver = () => {
		pageMenuObserver?.disconnect()
		pageMenuObserver = null

		const rect = menu.getBoundingClientRect()
		if (rect.width === 0 || rect.height === 0) {
			menu.classList.remove('page-menu--hidden')
			return
		}

		pageMenuObserver = new IntersectionObserver(
			([entry]) => {
				menu.classList.toggle(
					'page-menu--hidden',
					Boolean(entry?.isIntersecting)
				)
			},
			{
				root: null,
				rootMargin: getPageMenuRootMargin(menu),
				threshold: 0
			}
		)

		pageMenuObserver.observe(footer)
	}

	createObserver()
	pageMenuOnResize = createObserver
	window.addEventListener('resize', pageMenuOnResize)
}

function initLazyVideos() {
	videoObserver?.disconnect()
	videoObserver = null

	const videos = qsa('video.video-ll')
	if (!videos.length) return

	videoObserver = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return

				entry.target.load()
				entry.target.play()
				videoObserver.unobserve(entry.target)
			})
		},
		{
			rootMargin: '0px 0px -10% 0px',
			threshold: 0
		}
	)

	videos.forEach((el) => videoObserver.observe(el))
}

function destroyAjaxinate(instance) {
	if (!instance) return

	try {
		instance.destroy()
	} catch (error) {}
}

function getLocationKey(url) {
	try {
		const parsed = new URL(url, window.location.origin)
		return `${parsed.pathname}${parsed.search}`
	} catch {
		return url
	}
}

function getSwupPageUrl() {
	return getLocationKey(window.location.href)
}

function cacheSwupPage() {
	if (!swup) return

	const url = getSwupPageUrl()
	const html = `<!DOCTYPE html>${document.documentElement.outerHTML}`
	const page = { url, html }

	if (swup.cache.has(url)) {
		swup.cache.update(url, page)
	} else {
		swup.cache.set(url, page)
	}
}

function getCollectionRestoreState() {
	try {
		const raw = sessionStorage.getItem(COLLECTION_RESTORE_KEY)
		return raw ? JSON.parse(raw) : null
	} catch {
		return null
	}
}

function saveCollectionRestore(card) {
	if (!card || !qs('#collection')?.contains(card)) return

	try {
		sessionStorage.setItem(
			COLLECTION_RESTORE_KEY,
			JSON.stringify({
				collectionUrl: getSwupPageUrl(),
				productHref: card.getAttribute('href'),
				productHandle: card.dataset.productHandle || '',
				scrollY: window.scrollY
			})
		)
	} catch (error) {}

	cacheSwupPage()
}

function isHistoryBack(visit) {
	if (visit?.history?.popstate) return true
	if (visit) return false

	const nav = performance.getEntriesByType('navigation')[0]
	return nav?.type === 'back_forward'
}

function cardMatchesRestore(card, state) {
	if (!card || !state) return false

	if (
		state.productHandle &&
		card.dataset.productHandle === state.productHandle
	) {
		return true
	}

	if (!state.productHref) return false

	try {
		return (
			new URL(card.href, window.location.origin).pathname ===
			new URL(state.productHref, window.location.origin).pathname
		)
	} catch {
		return false
	}
}

function findRestoredCollectionCard(state) {
	return qsa('#collection [data-product-card]').find((card) =>
		cardMatchesRestore(card, state)
	)
}

function getCollectionNextUrl() {
	return qs('#collection-next a')?.href || null
}

async function loadCollectionNextPage(restoreId) {
	const url = getCollectionNextUrl()
	const container = qs('#collection')
	const pagination = qs('#collection-next')
	if (!url || !container || !pagination) return false

	const response = await fetch(url)
	if (restoreId !== collectionRestoreId) return false
	if (!response.ok) return false

	const doc = new DOMParser().parseFromString(
		await response.text(),
		'text/html'
	)
	if (restoreId !== collectionRestoreId) return false

	const newContainer = doc.querySelector('#collection')
	const newPagination = doc.querySelector('#collection-next')
	if (!newContainer || !qs('#collection')) return false

	container.insertAdjacentHTML('beforeend', newContainer.innerHTML)
	if (newPagination) pagination.innerHTML = newPagination.innerHTML

	safeCall(showReveals)
	safeCall(productCardInit)
	lazyLoadInstance?.update()
	cacheSwupPage()
	return true
}

function scrollToRestoredCollectionCard(card, scrollY) {
	qsa('#collection .reveal').forEach((el) => el.classList.add('entered'))

	if (typeof scrollY === 'number') {
		window.scrollTo(0, scrollY)
	}

	const rect = card.getBoundingClientRect()
	const inView = rect.top >= 0 && rect.bottom <= window.innerHeight
	if (!inView) {
		card.scrollIntoView({ block: 'center' })
	}
}

function shouldRestoreCollection(visit) {
	if (!qs('#collection')) return false
	if (!isHistoryBack(visit)) return false

	const state = getCollectionRestoreState()
	if (!state) return false

	return state.collectionUrl === getSwupPageUrl()
}

async function restoreCollectionScroll() {
	const restoreId = collectionRestoreId
	const state = getCollectionRestoreState()
	if (!state || state.collectionUrl !== getSwupPageUrl()) return

	let card = findRestoredCollectionCard(state)
	let pages = 0

	while (!card && getCollectionNextUrl() && pages < 50) {
		if (restoreId !== collectionRestoreId) return
		pages += 1
		const loaded = await loadCollectionNextPage(restoreId)
		if (!loaded) break
		card = findRestoredCollectionCard(state)
	}

	if (restoreId !== collectionRestoreId) return

	try {
		sessionStorage.removeItem(COLLECTION_RESTORE_KEY)
	} catch (error) {}

	await new Promise((resolve) => {
		requestAnimationFrame(() => requestAnimationFrame(resolve))
	})

	if (restoreId !== collectionRestoreId) return

	if (card) {
		scrollToRestoredCollectionCard(card, state.scrollY)
		return
	}

	if (typeof state.scrollY === 'number') {
		window.scrollTo(0, state.scrollY)
	}
}

function onCollectionPageLoaded() {
	safeCall(showReveals)
	safeCall(productCardInit)
	lazyLoadInstance?.update()
	cacheSwupPage()
}

function startCollectionAjaxinate() {
	if (!qs('#collection') || !qs('#collection-next')) return
	if (typeof Ajaxinate !== 'function') return

	destroyAjaxinate(collectionAjaxinate)
	collectionAjaxinate = new Ajaxinate({
		container: '#collection',
		pagination: '#collection-next',
		callback: onCollectionPageLoaded
	})
}

function initAjaxinate(visit) {
	destroyAjaxinate(collectionAjaxinate)
	destroyAjaxinate(blogAjaxinate)
	collectionAjaxinate = null
	blogAjaxinate = null

	if (qs('#collection') && qs('#collection-next')) {
		if (shouldRestoreCollection(visit)) {
			const restoreId = collectionRestoreId
			restoreCollectionScroll().finally(() => {
				if (restoreId !== collectionRestoreId) return
				startCollectionAjaxinate()
			})
		} else {
			startCollectionAjaxinate()
		}
	}

	if (qs('#blog') && qs('#blog-next') && typeof Ajaxinate === 'function') {
		blogAjaxinate = new Ajaxinate({
			container: '#blog',
			pagination: '#blog-next',
			callback: () => {
				safeCall(showReveals)
				lazyLoadInstance?.update()
			}
		})
	}
}

function getProductMedia() {
	const wrapper = qs('.product__media-wrapper')
	if (!wrapper) return null

	const mediaItems = qsa('.product__media-item', wrapper)
	const thumbnails = qsa('.product__thumbnails-item', wrapper)
	if (!mediaItems.length || !thumbnails.length) return null

	return { mediaItems, thumbnails }
}

function setActiveThumbnail(index, thumbnails) {
	const items = thumbnails || getProductMedia()?.thumbnails
	if (!items) return

	items.forEach((thumb, i) => {
		thumb.classList.toggle('active', i === index)
	})
}

function productMediaInit() {
	productMediaObserver?.disconnect()
	productMediaObserver = null

	const media = getProductMedia()
	if (!media) return

	setActiveThumbnail(0, media.thumbnails)

	productMediaObserver = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return

				const index = media.mediaItems.indexOf(entry.target)
				if (index === -1) return

				setActiveThumbnail(index, media.thumbnails)
			})
		},
		{
			rootMargin: '-45% 0px -45% 0px',
			threshold: 0
		}
	)

	media.mediaItems.forEach((item) => productMediaObserver.observe(item))
}

function updateProductDetailsIndicator(button) {
	const headingsContainer = qs('.product__details-headings')
	const indicator = qs('.product__details-indicator')
	const target =
		button ||
		qs('[data-product-details-heading].active') ||
		qs('[data-product-details-heading]')

	if (!target || !headingsContainer || !indicator) return

	const headingsRect = headingsContainer.getBoundingClientRect()
	const buttonRect = target.getBoundingClientRect()

	indicator.style.width = `${buttonRect.width}px`
	indicator.style.transform = `translateX(${
		buttonRect.left - headingsRect.left
	}px)`
}

function productDetailsInit() {
	if (productDetailsOnResize) {
		window.removeEventListener('resize', productDetailsOnResize)
		productDetailsOnResize = null
	}

	const indicator = qs('.product__details-indicator')
	const button =
		qs('[data-product-details-heading].active') ||
		qs('[data-product-details-heading]')

	if (!indicator || !button) return

	indicator.style.transition = 'none'
	updateProductDetailsIndicator(button)
	requestAnimationFrame(() => {
		indicator.style.transition = ''
	})

	productDetailsOnResize = () => updateProductDetailsIndicator()
	window.addEventListener('resize', productDetailsOnResize)
}

function destroyProductSwiper() {
	if (!productSwiper) return

	try {
		productSwiper.destroy(true, true)
	} catch (error) {}

	productSwiper = null
}

function productCarouselInit() {
	destroyProductSwiper()

	const carousel = qs('#productCarousel')
	if (!carousel || typeof Swiper !== 'function') return

	productSwiper = new Swiper(carousel, {
		slidesPerView: 1,
		spaceBetween: 0,
		speed: 800,
		observer: true,
		observeParents: true,
		watchOverflow: true,
		pagination: {
			el: '#productCarouselPagination',
			type: 'progressbar'
		}
	})

	requestAnimationFrame(() => productSwiper?.update())
}

function runInlineScripts(container = qs('#swup')) {
	if (!container) return

	qsa('script', container).forEach((oldScript) => {
		const type = (
			oldScript.getAttribute('type') || 'text/javascript'
		).toLowerCase()
		if (type !== 'text/javascript' && type !== 'module' && type !== '') return
		if (oldScript.hasAttribute('data-swup-ignore-script')) return

		const script = document.createElement('script')
		for (const attr of oldScript.attributes) {
			script.setAttribute(attr.name, attr.value)
		}
		script.textContent = oldScript.textContent
		oldScript.replaceWith(script)
	})
}

const boundProductCards = new WeakSet()

function productCardInit() {
	qsa('[data-product-card]').forEach((card) => {
		if (boundProductCards.has(card)) return
		boundProductCards.add(card)

		qsa('[data-product-card-variation-toggle]', card).forEach((toggle) => {
			const idx = toggle.dataset.productCardVariationToggle
			const image = qs(`[data-product-card-variation-image="${idx}"]`, card)

			toggle.addEventListener('click', (e) => {
				e.preventDefault()
				e.stopPropagation()

				const ex = qs('[data-product-card-variation-image].active', card)
				const exToggle = qs('[data-product-card-variation-toggle].active', card)

				image?.classList.add('active')
				toggle.classList.add('active')
				if (ex && image !== ex) ex.classList.remove('active')
				if (exToggle && toggle !== exToggle) {
					exToggle.classList.remove('active')
				}
			})
		})

		card.addEventListener('mouseleave', () => {
			const toggle = qs('[data-product-card-variation-toggle="0"]', card)
			const image = qs('[data-product-card-variation-image="0"]', card)
			const ex = qs('[data-product-card-variation-image].active', card)
			const exToggle = qs('[data-product-card-variation-toggle].active', card)

			image?.classList.add('active')
			toggle?.classList.add('active')
			if (ex && image !== ex) ex.classList.remove('active')
			if (exToggle && toggle !== exToggle) {
				exToggle.classList.remove('active')
			}
		})
	})
}

function initPage(visit) {
	lazyLoadInstance?.update()
	safeCall(showReveals)
	safeCall(initLazyVideos)
	safeCall(initPageMenuFooterOverlap)
	safeCall(() => initAjaxinate(visit))
	safeCall(productCardInit)
	safeCall(productMediaInit)
	safeCall(productCarouselInit)
	safeCall(productDetailsInit)
}

function unloadPage() {
	collectionRestoreId += 1
	destroyProductSwiper()
	productMediaObserver?.disconnect()
	productMediaObserver = null
	revealObserver?.disconnect()
	revealObserver = null
	videoObserver?.disconnect()
	videoObserver = null
	destroyPageMenuFooterOverlap()
	destroyAjaxinate(collectionAjaxinate)
	destroyAjaxinate(blogAjaxinate)
	collectionAjaxinate = null
	blogAjaxinate = null

	if (productDetailsOnResize) {
		window.removeEventListener('resize', productDetailsOnResize)
		productDetailsOnResize = null
	}
}

initPage()

if (swup) {
	swup.hooks.before('content:replace', () => unloadPage())

	swup.hooks.on('visit:start', (visit) => {
		closeAllModals()

		const card = visit.el?.closest?.('[data-product-card]')
		if (card) saveCollectionRestore(card)

		if (isCartPageUrl(visit.to.url)) {
			visit.cache.read = false
			visit.cache.write = false
		}
	})

	swup.hooks.on('content:replace', (visit) => {
		const nextTemplate = visit.to.document?.body?.dataset?.template
		if (nextTemplate) document.body.dataset.template = nextTemplate
	})

	swup.hooks.on('page:view', (visit) => {
		initPage(visit)
		safeCall(() => runInlineScripts())
	})

	swup.hooks.on('visit:end', () => {
		safeCall(productMediaInit)
		safeCall(productDetailsInit)
		safeCall(() => {
			if (!qs('#productCarousel')) return
			if (!productSwiper || productSwiper.destroyed) {
				productCarouselInit()
				return
			}
			productSwiper.update()
		})
	})
}
